import { Cloneable } from './Cloneable.js';
import { GVLError } from './errors/index.js';
import { Json } from './Json.js';
import { ConsentLanguages } from './model/index.js';
/**
 *
 *
 *
 *
 */
export class GVL extends Cloneable {
    static LANGUAGE_CACHE = new Map();
    static CACHE = new Map();
    static LATEST_CACHE_KEY = 0;
    static DEFAULT_LANGUAGE = 'EN';
    /**
 *
 */
    static consentLanguages = new ConsentLanguages();
    static baseUrl_;
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    static set baseUrl(url) {
        const notValid = /^https?:\/\/vendorlist\.consensu\.org\//;
        if (notValid.test(url)) {
            throw new GVLError('Invalid baseUrl!  You may not pull directly from vendorlist.consensu.org and must provide your own cache');
        }
        /*                                */
        if (url.length > 0 && url[url.length - 1] !== '/') {
            url += '/';
        }
        this.baseUrl_ = url;
    }
    ;
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
    static get baseUrl() {
        return this.baseUrl_;
    }
    /**
 *
 *
 *
 */
    static latestFilename = 'vendor-list.json';
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    static versionedFilename = 'archives/vendor-list-v[VERSION].json';
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    static languageFilename = 'purposes-[LANG].json';
    /**
 *
 *
 */
    readyPromise;
    /**
 *
 */
    gvlSpecificationVersion;
    /**
 *
 */
    vendorListVersion;
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 */
    tcfPolicyVersion;
    /**
 *
 *
 */
    lastUpdated;
    /**
 *
 */
    purposes;
    /**
 *
 */
    specialPurposes;
    /**
 *
 */
    features;
    /**
 *
 */
    specialFeatures;
    /**
 *
 */
    isReady_ = false;
    /**
 *
 */
    vendors_;
    vendorIds;
    /**
 *
 */
    fullVendorList;
    /**
 *
 */
    byPurposeVendorMap;
    /**
 *
 */
    bySpecialPurposeVendorMap;
    /**
 *
 */
    byFeatureVendorMap;
    /**
 *
 */
    bySpecialFeatureVendorMap;
    /**
 *
 */
    stacks;
    /**
 *
 */
    dataCategories;
    lang_;
    cacheLang_;
    isLatest = false;
    /**
 *
 *
 *
 *
 *
 */
    constructor(versionOrVendorList, options) {
        super();
        /**
 *
 *
 */
        let url = GVL.baseUrl;
        let parsedLanguage = options?.language;
        if (parsedLanguage) {
            try {
                parsedLanguage = GVL.consentLanguages.parseLanguage(parsedLanguage);
            }
            catch (e) {
                throw new GVLError('Error during parsing the language: ' + e.message);
            }
        }
        this.lang_ = parsedLanguage || GVL.DEFAULT_LANGUAGE;
        this.cacheLang_ = parsedLanguage || GVL.DEFAULT_LANGUAGE;
        if (this.isVendorList(versionOrVendorList)) {
            this.populate(versionOrVendorList);
            this.readyPromise = Promise.resolve();
        }
        else {
            if (!url) {
                throw new GVLError('must specify GVL.baseUrl before loading GVL json');
            }
            if (versionOrVendorList > 0) {
                const version = versionOrVendorList;
                if (GVL.CACHE.has(version)) {
                    this.populate(GVL.CACHE.get(version));
                    this.readyPromise = Promise.resolve();
                }
                else {
                    /*                     */
                    url += GVL.versionedFilename.replace('[VERSION]', String(version));
                    this.readyPromise = this.fetchJson(url);
                }
            }
            else {
                /**
 *
 *
 *
 *
 *
 */
                if (GVL.CACHE.has(GVL.LATEST_CACHE_KEY)) {
                    this.populate(GVL.CACHE.get(GVL.LATEST_CACHE_KEY));
                    this.readyPromise = Promise.resolve();
                }
                else {
                    this.isLatest = true;
                    this.readyPromise = this.fetchJson(url + GVL.latestFilename);
                }
            }
        }
    }
    /**
 *
 *
 *
 *
 *
 *
 */
    static emptyLanguageCache(lang) {
        let result = false;
        if (lang == null && GVL.LANGUAGE_CACHE.size > 0) {
            GVL.LANGUAGE_CACHE = new Map();
            result = true;
        }
        else if (typeof lang === 'string' && this.consentLanguages.has(lang.toUpperCase())) {
            GVL.LANGUAGE_CACHE.delete(lang.toUpperCase());
            result = true;
        }
        return result;
    }
    /**
 *
 *
 *
 *
 *
 */
    static emptyCache(vendorListVersion) {
        let retr = false;
        if (Number.isInteger(vendorListVersion) && vendorListVersion >= 0) {
            GVL.CACHE.delete(vendorListVersion);
            retr = true;
        }
        else if (vendorListVersion === undefined) {
            GVL.CACHE = new Map();
            retr = true;
        }
        return retr;
    }
    cacheLanguage() {
        if (!GVL.LANGUAGE_CACHE.has(this.cacheLang_)) {
            GVL.LANGUAGE_CACHE.set(this.cacheLang_, {
                purposes: this.purposes,
                specialPurposes: this.specialPurposes,
                features: this.features,
                specialFeatures: this.specialFeatures,
                stacks: this.stacks,
                dataCategories: this.dataCategories,
            });
        }
    }
    async fetchJson(url) {
        try {
            this.populate(await Json.fetch(url));
        }
        catch (err) {
            throw new GVLError(err.message);
        }
    }
    /**
 *
 *
 *
 *
 *
 */
    getJson() {
        return {
            gvlSpecificationVersion: this.gvlSpecificationVersion,
            vendorListVersion: this.vendorListVersion,
            tcfPolicyVersion: this.tcfPolicyVersion,
            lastUpdated: this.lastUpdated,
            purposes: this.clonePurposes(),
            specialPurposes: this.cloneSpecialPurposes(),
            features: this.cloneFeatures(),
            specialFeatures: this.cloneSpecialFeatures(),
            stacks: this.cloneStacks(),
            ...(this.dataCategories ? { dataCategories: this.cloneDataCategories() } : {}),
            vendors: this.cloneVendors(),
        };
    }
    cloneSpecialFeatures() {
        const features = {};
        for (const featureId of Object.keys(this.specialFeatures)) {
            features[featureId] = GVL.cloneFeature(this.specialFeatures[featureId]);
        }
        return features;
    }
    cloneFeatures() {
        const features = {};
        for (const featureId of Object.keys(this.features)) {
            features[featureId] = GVL.cloneFeature(this.features[featureId]);
        }
        return features;
    }
    cloneStacks() {
        const stacks = {};
        for (const stackId of Object.keys(this.stacks)) {
            stacks[stackId] = GVL.cloneStack(this.stacks[stackId]);
        }
        return stacks;
    }
    cloneDataCategories() {
        const dataCategories = {};
        for (const dataCategoryId of Object.keys(this.dataCategories)) {
            dataCategories[dataCategoryId] = GVL.cloneDataCategory(this.dataCategories[dataCategoryId]);
        }
        return dataCategories;
    }
    cloneSpecialPurposes() {
        const purposes = {};
        for (const purposeId of Object.keys(this.specialPurposes)) {
            purposes[purposeId] = GVL.clonePurpose(this.specialPurposes[purposeId]);
        }
        return purposes;
    }
    clonePurposes() {
        const purposes = {};
        for (const purposeId of Object.keys(this.purposes)) {
            purposes[purposeId] = GVL.clonePurpose(this.purposes[purposeId]);
        }
        return purposes;
    }
    static clonePurpose(purpose) {
        return {
            id: purpose.id,
            name: purpose.name,
            description: purpose.description,
            ...(purpose.descriptionLegal ? { descriptionLegal: purpose.descriptionLegal } : {}),
            ...(purpose.illustrations ? { illustrations: Array.from(purpose.illustrations) } : {}),
        };
    }
    static cloneFeature(feature) {
        return {
            id: feature.id,
            name: feature.name,
            description: feature.description,
            ...(feature.descriptionLegal ? { descriptionLegal: feature.descriptionLegal } : {}),
            ...(feature.illustrations ? { illustrations: Array.from(feature.illustrations) } : {}),
        };
    }
    static cloneDataCategory(dataCategory) {
        return {
            id: dataCategory.id,
            name: dataCategory.name,
            description: dataCategory.description,
        };
    }
    static cloneStack(stack) {
        return {
            id: stack.id,
            name: stack.name,
            description: stack.description,
            purposes: Array.from(stack.purposes),
            specialFeatures: Array.from(stack.specialFeatures),
        };
    }
    static cloneDataRetention(dataRetention) {
        return {
            ...(typeof dataRetention.stdRetention === 'number' ? { stdRetention: dataRetention.stdRetention } : {}),
            purposes: { ...dataRetention.purposes },
            specialPurposes: { ...dataRetention.specialPurposes },
        };
    }
    static cloneVendorUrls(urls) {
        return urls.map((url) => ({
            langId: url.langId,
            privacy: url.privacy,
            ...(url.legIntClaim ? { legIntClaim: url.legIntClaim } : {}),
        }));
    }
    static cloneVendor(vendor) {
        return {
            id: vendor.id,
            name: vendor.name,
            purposes: Array.from(vendor.purposes),
            legIntPurposes: Array.from(vendor.legIntPurposes),
            flexiblePurposes: Array.from(vendor.flexiblePurposes),
            specialPurposes: Array.from(vendor.specialPurposes),
            features: Array.from(vendor.features),
            specialFeatures: Array.from(vendor.specialFeatures),
            ...(vendor.overflow ? { overflow: { httpGetLimit: vendor.overflow.httpGetLimit } } : {}),
            ...(typeof vendor.cookieMaxAgeSeconds === 'number' || vendor.cookieMaxAgeSeconds === null ? { cookieMaxAgeSeconds: vendor.cookieMaxAgeSeconds } : {}),
            ...(vendor.usesCookies !== undefined ? { usesCookies: vendor.usesCookies } : {}),
            ...(vendor.policyUrl ? { policyUrl: vendor.policyUrl } : {}),
            ...(vendor.cookieRefresh !== undefined ? { cookieRefresh: vendor.cookieRefresh } : {}),
            ...(vendor.usesNonCookieAccess !== undefined ? { usesNonCookieAccess: vendor.usesNonCookieAccess } : {}),
            ...(vendor.dataRetention ? { dataRetention: this.cloneDataRetention(vendor.dataRetention) } : {}),
            ...(vendor.urls ? { urls: this.cloneVendorUrls(vendor.urls) } : {}),
            ...(vendor.dataDeclaration ? { dataDeclaration: Array.from(vendor.dataDeclaration) } : {}),
            ...(vendor.deviceStorageDisclosureUrl ? { deviceStorageDisclosureUrl: vendor.deviceStorageDisclosureUrl } : {}),
            ...(vendor.deletedDate ? { deletedDate: vendor.deletedDate } : {}),
        };
    }
    cloneVendors() {
        const vendors = {};
        for (const vendorId of Object.keys(this.fullVendorList)) {
            vendors[vendorId] = GVL.cloneVendor(this.fullVendorList[vendorId]);
        }
        return vendors;
    }
    /**
 *
 *
 *
 *
 *
 *
 */
    async changeLanguage(lang) {
        let parsedLanguage = lang;
        try {
            parsedLanguage = GVL.consentLanguages.parseLanguage(lang);
        }
        catch (e) {
            throw new GVLError('Error during parsing the language: ' + e.message);
        }
        const cacheLang = lang.toUpperCase();
        /*                                                    */
        if (parsedLanguage.toLowerCase() === GVL.DEFAULT_LANGUAGE.toLowerCase() && !GVL.LANGUAGE_CACHE.has(cacheLang)) {
            return;
        }
        if (parsedLanguage !== this.lang_) {
            this.lang_ = parsedLanguage;
            if (GVL.LANGUAGE_CACHE.has(cacheLang)) {
                const cached = GVL.LANGUAGE_CACHE.get(cacheLang);
                for (const prop in cached) {
                    if (cached.hasOwnProperty(prop)) {
                        this[prop] = cached[prop];
                    }
                }
            }
            else {
                /*                      */
                const url = GVL.baseUrl + GVL.languageFilename.replace('[LANG]', this.lang_.toLowerCase());
                try {
                    await this.fetchJson(url);
                    this.cacheLang_ = cacheLang;
                    this.cacheLanguage();
                }
                catch (err) {
                    throw new GVLError('unable to load language: ' + err.message);
                }
            }
        }
    }
    get language() {
        return this.lang_;
    }
    isVendorList(gvlObject) {
        return gvlObject !== undefined && gvlObject.vendors !== undefined;
    }
    populate(gvlObject) {
        /**
 *
 *
 */
        this.purposes = gvlObject.purposes;
        this.specialPurposes = gvlObject.specialPurposes;
        this.features = gvlObject.features;
        this.specialFeatures = gvlObject.specialFeatures;
        this.stacks = gvlObject.stacks;
        this.dataCategories = gvlObject.dataCategories;
        if (this.isVendorList(gvlObject)) {
            this.gvlSpecificationVersion = gvlObject.gvlSpecificationVersion;
            this.tcfPolicyVersion = gvlObject.tcfPolicyVersion;
            this.vendorListVersion = gvlObject.vendorListVersion;
            this.lastUpdated = gvlObject.lastUpdated;
            if (typeof this.lastUpdated === 'string') {
                this.lastUpdated = new Date(this.lastUpdated);
            }
            this.vendors_ = gvlObject.vendors;
            this.fullVendorList = gvlObject.vendors;
            this.mapVendors();
            this.isReady_ = true;
            if (this.isLatest) {
                /**
 *
 *
 */
                GVL.CACHE.set(GVL.LATEST_CACHE_KEY, this.getJson());
            }
            /**
 *
 *
 *
 */
            if (!GVL.CACHE.has(this.vendorListVersion)) {
                GVL.CACHE.set(this.vendorListVersion, this.getJson());
            }
        }
        this.cacheLanguage();
    }
    mapVendors(vendorIds) {
        /*                               */
        this.byPurposeVendorMap = {};
        this.bySpecialPurposeVendorMap = {};
        this.byFeatureVendorMap = {};
        this.bySpecialFeatureVendorMap = {};
        /*                                         */
        Object.keys(this.purposes).forEach((purposeId) => {
            this.byPurposeVendorMap[purposeId] = {
                legInt: new Set(),
                consent: new Set(),
                flexible: new Set(),
            };
        });
        /*                                                 */
        Object.keys(this.specialPurposes).forEach((purposeId) => {
            this.bySpecialPurposeVendorMap[purposeId] = new Set();
        });
        /*                                         */
        Object.keys(this.features).forEach((featureId) => {
            this.byFeatureVendorMap[featureId] = new Set();
        });
        /*                                         */
        Object.keys(this.specialFeatures).forEach((featureId) => {
            this.bySpecialFeatureVendorMap[featureId] = new Set();
        });
        if (!Array.isArray(vendorIds)) {
            vendorIds = Object.keys(this.fullVendorList).map((vId) => +vId);
        }
        this.vendorIds = new Set(vendorIds);
        /*                                          */
        this.vendors_ = vendorIds.reduce((vendors, vendorId) => {
            const vendor = this.vendors_[String(vendorId)];
            if (vendor && vendor.deletedDate === undefined) {
                vendor.purposes.forEach((purposeId) => {
                    const purpGroup = this.byPurposeVendorMap[String(purposeId)];
                    purpGroup.consent.add(vendorId);
                });
                vendor.specialPurposes.forEach((purposeId) => {
                    this.bySpecialPurposeVendorMap[String(purposeId)].add(vendorId);
                });
                vendor.legIntPurposes.forEach((purposeId) => {
                    this.byPurposeVendorMap[String(purposeId)].legInt.add(vendorId);
                });
                /*                 */
                if (vendor.flexiblePurposes) {
                    vendor.flexiblePurposes.forEach((purposeId) => {
                        this.byPurposeVendorMap[String(purposeId)].flexible.add(vendorId);
                    });
                }
                vendor.features.forEach((featureId) => {
                    this.byFeatureVendorMap[String(featureId)].add(vendorId);
                });
                vendor.specialFeatures.forEach((featureId) => {
                    this.bySpecialFeatureVendorMap[String(featureId)].add(vendorId);
                });
                vendors[vendorId] = vendor;
            }
            return vendors;
        }, {});
    }
    getFilteredVendors(purposeOrFeature, id, subType, special) {
        const properPurposeOrFeature = purposeOrFeature.charAt(0).toUpperCase() + purposeOrFeature.slice(1);
        let vendorSet;
        const retr = {};
        if (purposeOrFeature === 'purpose' && subType) {
            vendorSet = this['by' + properPurposeOrFeature + 'VendorMap'][String(id)][subType];
        }
        else {
            vendorSet = this['by' + (special ? 'Special' : '') + properPurposeOrFeature + 'VendorMap'][String(id)];
        }
        vendorSet.forEach((vendorId) => {
            retr[String(vendorId)] = this.vendors[String(vendorId)];
        });
        return retr;
    }
    /**
 *
 *
 *
 *
 */
    getVendorsWithConsentPurpose(purposeId) {
        return this.getFilteredVendors('purpose', purposeId, 'consent');
    }
    /**
 *
 *
 *
 *
 */
    getVendorsWithLegIntPurpose(purposeId) {
        return this.getFilteredVendors('purpose', purposeId, 'legInt');
    }
    /**
 *
 *
 *
 *
 */
    getVendorsWithFlexiblePurpose(purposeId) {
        return this.getFilteredVendors('purpose', purposeId, 'flexible');
    }
    /**
 *
 *
 *
 *
 */
    getVendorsWithSpecialPurpose(specialPurposeId) {
        return this.getFilteredVendors('purpose', specialPurposeId, undefined, true);
    }
    /**
 *
 *
 *
 *
 */
    getVendorsWithFeature(featureId) {
        return this.getFilteredVendors('feature', featureId);
    }
    /**
 *
 *
 *
 *
 */
    getVendorsWithSpecialFeature(specialFeatureId) {
        return this.getFilteredVendors('feature', specialFeatureId, undefined, true);
    }
    /**
 *
 *
 *
 *
 */
    get vendors() {
        return this.vendors_;
    }
    /**
 *
 *
 *
 *
 */
    narrowVendorsTo(vendorIds) {
        this.mapVendors(vendorIds);
    }
    /**
 *
 *
 *
 *
 *
 *
 */
    get isReady() {
        return this.isReady_;
    }
    /**
 *
 *
 *
 *
 */
    clone() {
        const result = new GVL(this.getJson());
        /**
 *
 *
 */
        if (this.lang_ !== GVL.DEFAULT_LANGUAGE) {
            /**
 *
 *
 *
 *
 */
            result.changeLanguage(this.lang_);
        }
        return result;
    }
    static isInstanceOf(questionableInstance) {
        const isSo = typeof questionableInstance === 'object';
        return (isSo && typeof questionableInstance.narrowVendorsTo === 'function');
    }
}
